module.exports = __webpack_public_path__ + "img/AI-TEST-ROOM-03-m.b6ec31fd.png";